import PropTypes from 'prop-types'
import classnames from 'classnames'
import './SearchInput.scss'

const SearchInput = ({ className, placeholder, onChange, value }) => (
  <div className={classnames('search-input-container', { [className]: !!className })}>
    <i className='fa fa-search search-icon' />
    <input
      className='search-input'
      onChange={onChange}
      value={value}
      style={{
        borderRadius: '5px',
        paddingLeft: '10px',
        paddingRight: '10px',
      }}
      placeholder={placeholder}
    />
  </div>
)

SearchInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default SearchInput
